import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ConsentContext = createContext(null);

const STORAGE_KEY = "bbm_cookie_consent_v1";

function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && parsed.version === 1) return parsed;
    return null;
  } catch (e) {
    return null;
  }
}

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(null); // null => not decided yet
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setConsent(readConsent());
    setReady(true);
  }, []);

  const save = useCallback((partial, lang = "no") => {
    const next = {
      version: 1,
      essential: true,
      analytics: !!partial.analytics,
      marketing: !!partial.marketing,
      updatedAt: new Date().toISOString(),
      lang,
    };
    setConsent(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      /* ignore */
    }
    return next;
  }, []);

  const acceptAll = useCallback((lang) => save({ analytics: true, marketing: true }, lang), [save]);
  const rejectAll = useCallback((lang) => save({ analytics: false, marketing: false }, lang), [save]);

  const value = {
    ready,
    consent, // null | {essential, analytics, marketing,...}
    decided: !!consent,
    analyticsAllowed: !!(consent && consent.analytics),
    save,
    acceptAll,
    rejectAll,
  };

  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
}

export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
}
